import React from 'react';
import PropTypes from 'prop-types';
import {
	Wrapper,
	SelectWrapper,
	StyledSelect,
	Label,
	SelectLabel,
	SelectLabelPlaceholder,
	Arrow,
} from './styles';
import { Tooltip } from 'react-tippy';
import { TooltipContent } from 'Waves/Waves.styles';
import { ApIcon, colors } from '@alixpartners/ui-components';

export class Select extends React.Component {
	static propTypes = {
		label: PropTypes.string,
		name: PropTypes.string.isRequired,
		options: PropTypes.arrayOf(
			PropTypes.oneOfType([PropTypes.object, PropTypes.string])
		).isRequired,
		value: PropTypes.string,
		onChange: PropTypes.func.isRequired,
	};

	render() {
		const {
			label,
			name,
			options,
			value,
			tooltipText,
			onChange,
			...otherProps
		} = this.props;

		return (
			<Wrapper {...otherProps}>
				<Label>
					{label}{' '}
					<Tooltip
						position="top"
						animation="fade"
						arrow
						html={<TooltipContent>{tooltipText}</TooltipContent>}
						trigger="mouseenter"
					>
						<ApIcon
							iconName="baseline_help"
							iconSize={11}
							iconColor={colors.grey6}
						/>
					</Tooltip>
				</Label>
				<SelectWrapper>
					<StyledSelect name={name} value={value || ''} onChange={onChange}>
						{!value && <option value="" disabled>{`Select ${label}`}</option>}
						{options.map(getOptionByValue)}
					</StyledSelect>
					{value ? (
						<SelectLabel>
							{value}
							<Arrow />
						</SelectLabel>
					) : (
						<SelectLabelPlaceholder>
							{`Select ${label}`}
							<Arrow />
						</SelectLabelPlaceholder>
					)}
				</SelectWrapper>
			</Wrapper>
		);
	}
}

const getOptionByValue = value => {
	if (value.key && value.value) {
		return (
			<option key={value.key} value={value.value}>
				{value.value}
			</option>
		);
	}

	return (
		<option key={value} value={value}>
			{value}
		</option>
	);
};
